import { c as _c } from "react/compiler-runtime";
import type { HostedBusinessOwner } from '@onefootprint/request-types';
import { Button, Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
export type EditFormValues = {
  firstName: string;
  lastName: string;
  ownershipStake: number;
};
export type BosListEditFormProps = {
  bo: HostedBusinessOwner;
  onSubmit: (formValues: EditFormValues) => void;
  onCancel: () => void;
};
export const BosListEditForm = t0 => {
  const $ = _c(66);
  const {
    bo,
    onSubmit,
    onCancel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectBusinessData.beneficialOwners.form"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const t2 = bo.decryptedData["id.first_name"];
  const t3 = bo.decryptedData["id.last_name"];
  let t4;
  if ($[1] !== bo.ownershipStake || $[2] !== t2 || $[3] !== t3) {
    t4 = {
      defaultValues: {
        firstName: t2,
        lastName: t3,
        ownershipStake: bo.ownershipStake
      }
    };
    $[1] = bo.ownershipStake;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const methods = useForm(t4);
  const {
    handleSubmit,
    formState: t5
  } = methods;
  const {
    isSubmitting
  } = t5;
  let t6;
  if ($[5] !== handleSubmit || $[6] !== onSubmit) {
    t6 = handleSubmit(onSubmit);
    $[5] = handleSubmit;
    $[6] = onSubmit;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t(_temp2);
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <Form.Input name="firstName" label={t7} data-dd-privacy="mask" placeholder={t8} disabled={true} />;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t(_temp3);
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t(_temp4);
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <Form.Input name="lastName" label={t10} data-dd-privacy="mask" data-dd-action-name="Last name input" placeholder={t11} disabled={true} />;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t(_temp5);
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t) {
    t14 = t(_temp6);
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t) {
    t15 = t(_temp7);
    $[26] = t;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15) {
    t16 = {
      value: 0,
      message: t15
    };
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = t(_temp8);
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17) {
    t18 = {
      value: 100,
      message: t17
    };
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t14 || $[35] !== t16 || $[36] !== t18) {
    t19 = {
      required: t14,
      min: t16,
      max: t18,
      valueAsNumber: true
    };
    $[34] = t14;
    $[35] = t16;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t13 || $[39] !== t19) {
    t20 = <Form.Input name="ownershipStake" label={t13} autoFocus={true} type="number" data-dd-privacy="mask" data-dd-action-name="Ownership stake input" placeholder="100" min="0" max="100" rules={t19} />;
    $[38] = t13;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t) {
    t21 = t(_temp9);
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== isSubmitting || $[44] !== onCancel || $[45] !== t21) {
    t22 = <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>{t21}</Button>;
    $[43] = isSubmitting;
    $[44] = onCancel;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t) {
    t23 = t(_temp10);
    $[47] = t;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== isSubmitting || $[50] !== t23) {
    t24 = <Button type="submit" loading={isSubmitting}>{t23}</Button>;
    $[49] = isSubmitting;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t22 || $[53] !== t24) {
    t25 = <div className="flex justify-end gap-2">{t22}{t24}</div>;
    $[52] = t22;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t12 || $[56] !== t20 || $[57] !== t25 || $[58] !== t9) {
    t26 = <div className="flex flex-col gap-5">{t9}{t12}{t20}{t25}</div>;
    $[55] = t12;
    $[56] = t20;
    $[57] = t25;
    $[58] = t9;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t26 || $[61] !== t6) {
    t27 = <form onSubmit={t6}>{t26}</form>;
    $[60] = t26;
    $[61] = t6;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== methods || $[64] !== t27) {
    t28 = <FormProvider {...methods}>{t27}</FormProvider>;
    $[63] = methods;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  return t28;
};
function _temp($) {
  return $.fields["first-name"].label;
}
function _temp2($_0) {
  return $_0.fields["first-name"].placeholder;
}
function _temp3($_1) {
  return $_1.fields["last-name"].label;
}
function _temp4($_2) {
  return $_2.fields["last-name"].placeholder;
}
function _temp5($_3) {
  return $_3.fields["ownership-stake"].label;
}
function _temp6($_4) {
  return $_4.fields["ownership-stake"].errors.required;
}
function _temp7($_5) {
  return $_5.fields["ownership-stake"].errors.min;
}
function _temp8($_6) {
  return $_6.fields["ownership-stake"].errors.max;
}
function _temp9($_7) {
  return $_7.cancel;
}
function _temp10($_8) {
  return $_8.save;
}